import { format as dateFnsFormat } from 'date-fns';

const formats = {
  date: {
    eu: 'ccc d MMM yyyy',
    us: 'ccc MMM d yyyy',
  },
  dateNoWeekDay: {
    eu: 'd MMM yyyy',
    us: 'MMM d yyyy',
  },
  dateNoYear: {
    eu: 'ccc d MMM',
    us: 'ccc MMM d',
  },
  time: {
    eu: 'HH:mm',
    us: 'h:mma',
  },
};

const defaultFormat = {
  DATE: formats.date.eu,
  DATE_TIME: `${formats.date.eu} 'at' ${formats.time.eu}`,
  DATE_TIME_NO_WEEK_DAY: `${formats.dateNoWeekDay.eu} 'at' ${formats.time.eu}`,
  DATE_TIME_NO_YEAR: `${formats.dateNoYear.eu} 'at' ${formats.time.eu}`,
  TIME: formats.time.eu,
};

const DATE_TIME_FORMATS: Record<string, typeof defaultFormat> = {
  'en-GB': {
    DATE: formats.date.eu,
    DATE_TIME: `${formats.date.eu} 'at' ${formats.time.us}`,
    DATE_TIME_NO_WEEK_DAY: `${formats.dateNoWeekDay.eu} 'at' ${formats.time.us}`,
    DATE_TIME_NO_YEAR: `${formats.dateNoYear.eu} 'at' ${formats.time.us}`,
    TIME: formats.time.us,
  },
  'en-IE': {
    DATE: formats.date.eu,
    DATE_TIME: `${formats.date.eu} 'at' ${formats.time.us}`,
    DATE_TIME_NO_WEEK_DAY: `${formats.dateNoWeekDay.eu} 'at' ${formats.time.us}`,
    DATE_TIME_NO_YEAR: `${formats.dateNoYear.eu} 'at' ${formats.time.us}`,
    TIME: formats.time.us,
  },
  'en-US': {
    DATE: formats.date.eu,
    DATE_TIME: `${formats.date.eu} 'at' ${formats.time.us}`,
    DATE_TIME_NO_WEEK_DAY: `${formats.dateNoWeekDay.eu} 'at' ${formats.time.us}`,
    DATE_TIME_NO_YEAR: `${formats.dateNoYear.eu} 'at' ${formats.time.us}`,
    TIME: formats.time.us,
  },
};

const format = (
  date: Date | number,
  formatType: DateTimeFormats,
  locale: string,
  dateFnsLocale?: Locale
) => {
  const selectedLocale = dateFnsLocale?.code || locale;
  const formatString = ((selectedLocale && DATE_TIME_FORMATS[selectedLocale]) || defaultFormat)[formatType];

  return dateFnsFormat(date, formatString, { locale: dateFnsLocale });
};

export const localTime = { format };
export type DateTimeFormats = keyof typeof defaultFormat;
